var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9275 0.352057C21.8078 -0.269604 20.2615 -0.0416752 19.4617 0.828598L9.89086 11.4584L4.23899 7.06555C3.27924 6.31961 1.67956 6.31961 0.719813 7.06555C-0.239938 7.8115 -0.239938 9.05482 0.719813 9.80077L8.45114 15.8098C8.93092 16.1827 9.57085 16.3693 10.2107 16.3693H10.2373H10.4772C11.1703 16.3278 11.8368 16.0377 12.29 15.5612L23.5671 3.04583C24.3407 2.15462 24.0474 0.952812 22.9277 0.351946L22.9275 0.352057Z",
    fill: "#84889F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsIcon);
export default __webpack_public_path__ + "static/media/benefits-icon.2ec8849525a45eadb36eeba78a16c3b6.svg";
export { ForwardRef as ReactComponent };